import { IconComponent } from '@fronton/icons-react/types';
import { DropIcon, LeafIcon, PaletteIcon, PawPrintIcon } from '@fronton/icons-react';
import { ProductCardStructure } from 'common/components';
import { INTERIOR_DOORS_CDN_PATH } from 'landings/interior-doors/interior-doors-constants';

export type ModerMaterialsProductStructure = {
  properties: {
    name: string;
    value: string;
  }[];
  iconList: {
    icon: IconComponent;
    textColor: string;
  }[];
} & ProductCardStructure;

export const INTERIOR_DOORS_MODERN_MATERIAL_LIST: ModerMaterialsProductStructure[] = [
  {
    alt: 'Двери в эмали',
    name: 'Двери в эмали',
    imgSrc: `${INTERIOR_DOORS_CDN_PATH}/modern-materials/1.jpg/1.jpg`,
    properties: [
      { name: 'Влагостойкость: ', value: 'да' },
      { name: 'Защита от царапин: ', value: 'нет' },
      { name: 'Под покраску: ', value: 'нет' },
      { name: 'Экологичность: ', value: 'да' },
    ],
    iconList: [
      { icon: DropIcon, textColor: 'text-primary' },
      { icon: PawPrintIcon, textColor: 'control-secondary' },
      { icon: PaletteIcon, textColor: 'control-secondary' },
      { icon: LeafIcon, textColor: 'text-primary' },
    ],
  },
  {
    alt: 'Двери CPL и Hardflex',
    name: 'Двери CPL и Hardflex',
    imgSrc: `${INTERIOR_DOORS_CDN_PATH}/modern-materials/2.jpg/2.jpg`,
    properties: [
      { name: 'Влагостойкость: ', value: 'да' },
      { name: 'Защита от царапин: ', value: 'да' },
      { name: 'Под покраску: ', value: 'нет' },
      { name: 'Экологичность: ', value: 'да' },
    ],
    iconList: [
      { icon: DropIcon, textColor: 'text-primary' },
      { icon: PawPrintIcon, textColor: 'text-primary' },
      { icon: PaletteIcon, textColor: 'control-secondary' },
      { icon: LeafIcon, textColor: 'text-primary' },
    ],
  },
  {
    alt: 'Двери в плёнке ПВХ и ПП',
    name: 'Двери в плёнке ПВХ и ПП',
    imgSrc: `${INTERIOR_DOORS_CDN_PATH}/modern-materials/3.jpg/3.jpg`,
    properties: [
      { name: 'Влагостойкость: ', value: 'да' },
      { name: 'Защита от царапин: ', value: 'нет' },
      { name: 'Под покраску: ', value: 'нет' },
      { name: 'Экологичность: ', value: 'да' },
    ],
    iconList: [
      { icon: DropIcon, textColor: 'text-primary' },
      { icon: PawPrintIcon, textColor: 'control-secondary' },
      { icon: PaletteIcon, textColor: 'control-secondary' },
      { icon: LeafIcon, textColor: 'text-primary' },
    ],
  },
  {
    alt: 'Двери из массива',
    name: 'Двери из массива',
    imgSrc: `${INTERIOR_DOORS_CDN_PATH}/modern-materials/4.jpg/4.jpg`,
    properties: [
      { name: 'Влагостойкость: ', value: 'нет' },
      { name: 'Защита от царапин: ', value: 'нет' },
      { name: 'Под покраску: ', value: 'да' },
      { name: 'Экологичность: ', value: 'да' },
    ],
    iconList: [
      { icon: DropIcon, textColor: 'control-secondary' },
      { icon: PawPrintIcon, textColor: 'control-secondary' },
      { icon: PaletteIcon, textColor: 'text-primary' },
      { icon: LeafIcon, textColor: 'text-primary' },
    ],
  },
  {
    alt: 'Натуральный шпон',
    name: 'Натуральный шпон',
    imgSrc: `${INTERIOR_DOORS_CDN_PATH}/modern-materials/5.jpg/5.jpg`,
    properties: [
      { name: 'Влагостойкость: ', value: 'нет' },
      { name: 'Защита от царапин: ', value: 'нет' },
      { name: 'Под покраску: ', value: 'нет' },
      { name: 'Экологичность: ', value: 'да' },
    ],
    iconList: [
      { icon: DropIcon, textColor: 'control-secondary' },
      { icon: PawPrintIcon, textColor: 'control-secondary' },
      { icon: PaletteIcon, textColor: 'control-secondary' },
      { icon: LeafIcon, textColor: 'text-primary' },
    ],
  },
];
